"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const date_fns_1 = require("date-fns");
const react_1 = tslib_1.__importDefault(require("react"));
const DayPickerInput_1 = tslib_1.__importDefault(require("react-day-picker/DayPickerInput"));
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const StyledFunctions_1 = require("../../helpers/StyledFunctions");
const Flex_1 = require("../Elements/Flex");
const Texts_1 = require("../Texts");
const StyledComponents_1 = require("./StyledComponents");
const defaultProps = {
    showError: true,
    dateFormat: 'MM/DD/YYYY',
};
const DatePickerContainer = (0, styled_components_1.default)(StyledComponents_1.Container) `
  position: relative;
`;
const DatePickerInput = ({ label, hint, error, value, prependElements, appendElements, showError, onDateChange, dateFormat = defaultProps.dateFormat, ...restProps }) => {
    const { margins, rest } = (0, StyledFunctions_1.extractMarginAndPadding)(restProps);
    const [flex, notFlex] = (0, Flex_1.extractFlex)(rest);
    const [elementSizes] = (0, StyledFunctions_1.extractElementSizes)(notFlex);
    return (react_1.default.createElement(DatePickerContainer, { ...margins, ...flex },
        label && react_1.default.createElement(Texts_1.LabelText, null, label),
        react_1.default.createElement(StyledComponents_1.InputContainer, { error: !!error, ...elementSizes },
            prependElements,
            react_1.default.createElement(DayPickerInput_1.default, { formatDate: date => (0, date_fns_1.format)(date, dateFormat), value: value, onDayChange: onDateChange, format: dateFormat, placeholder: dateFormat }),
            appendElements),
        showError && react_1.default.createElement(Texts_1.HintText, null,
            error || hint,
            "\u00A0")));
};
DatePickerInput.defaultProps = defaultProps;
exports.default = DatePickerInput;
